import { render, staticRenderFns } from "./_carouselImages.vue?vue&type=template&id=487565fb"
import script from "./_carouselImages.vue?vue&type=script&lang=js"
export * from "./_carouselImages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports